module.exports = __webpack_public_path__ + "img/bg.3ff73aff.png";